import React from "react";
import Hero from "../components/Hero";
import Middle from "../components/Middle";
import End from "../components/End"

const Home = () => {
  return <div>
    <Hero/>
    <Middle/>
    <End/>
  </div>;
};

export default Home;
